import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

const SidebarItemInner = ({ title, isAiEnabled, isSoilSensor }) => {
  return (
    <>
      {/*<CameraIcon className={styles.sidebarItemIcon} />*/}
      <CroplerIcon name="camera" className={styles.sidebarItemIcon} />
      <span className={styles.sidebarItemTitle}>{title}</span>
      {isAiEnabled && <CroplerIcon name="aiColored" className={`${styles.sidebarItemAi}`} />}
      {isSoilSensor && <CroplerIcon name="cameraSoil" className={styles.sidebarItemSoil} />}
    </>
  );
};

export default SidebarItemInner;
